export default function Media() {
  const mediaItems = [
    {
      id: 1,
      type: 'interview',
      publication: 'Literary Review Magazine',
      title: 'The Power of Small Decisions',
      quote: 'Every choice we make, no matter how insignificant it may seem, has the potential to alter the course of our lives in ways we cannot immediately foresee.',
      date: 'February 2025',
      logo: 'ri-newspaper-line',
      link: '#'
    },
    {
      id: 2,
      type: 'podcast',
      publication: 'The Thoughtful Life Podcast',
      title: 'Episode 47: Gary Wilson on Decision Making',
      description: 'A deep dive into the psychology of choices and how to make decisions that align with your values.',
      date: 'January 2025',
      logo: 'ri-mic-line',
      link: '#'
    },
    {
      id: 3,
      type: 'video',
      publication: 'Author Spotlight Series',
      title: 'Behind the Book: Writing Process',
      description: 'Gary shares his journey from concept to publication and the personal experiences that shaped his writing.',
      date: 'December 2024',
      logo: 'ri-video-line',
      thumbnail: 'https://public.readdy.ai/ai/img_res/3fd4654e415034e701ecf4907aeb19ff.jpg',
      link: '#'
    },
    {
      id: 4,
      type: 'article',
      publication: 'Psychology Today',
      title: 'Understanding the Ripple Effect of Our Choices',
      quote: 'Wilson\'s insights into decision-making offer a fresh perspective on personal responsibility and the interconnectedness of our actions.',
      date: 'November 2024',
      logo: 'ri-article-line',
      link: '#'
    },
    {
      id: 5,
      type: 'interview',
      publication: 'New Jersey Monthly',
      title: 'Local Author Makes National Impact',
      description: 'A profile of Gary Wilson and his journey from New Jersey resident to published author with a growing national audience.',
      date: 'October 2024',
      logo: 'ri-newspaper-line',
      link: '#'
    },
    {
      id: 6,
      type: 'podcast',
      publication: 'Books & Beyond',
      title: 'Episode 112: Life-Changing Decisions',
      description: 'Gary discusses the most pivotal decisions in his life and how they inspired his writing.',
      date: 'September 2024',
      logo: 'ri-mic-line',
      link: '#'
    }
  ];

  return (
    <section id="media" className="py-24 bg-stone-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-6xl font-bold text-gray-900 mb-4">
            IN THE MEDIA
          </h2>
          <div className="w-24 h-1 bg-amber-600 mx-auto"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {mediaItems.map((item) => (
            <div 
              key={item.id}
              className="bg-white rounded-xl p-6 shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-1 group cursor-pointer"
            >
              {item.thumbnail ? (
                <div className="mb-4 rounded-lg overflow-hidden relative">
                  <img 
                    src={item.thumbnail}
                    alt={item.title}
                    className="w-full h-48 object-cover"
                  />
                  <div className="absolute inset-0 bg-black/40 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                    <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center">
                      <i className="ri-play-fill text-3xl text-amber-600"></i>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="mb-4 flex items-center justify-center h-16">
                  <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center">
                    <i className={`${item.logo} text-2xl text-amber-600`}></i>
                  </div>
                </div>
              )}
              
              <div className="text-xs font-medium text-amber-600 mb-2 uppercase tracking-wide">
                {item.publication}
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-3 leading-tight">
                {item.title}
              </h3>
              
              {item.quote && (
                <blockquote className="text-gray-600 text-sm italic leading-relaxed mb-3 border-l-2 border-amber-600 pl-4">
                  {item.quote}
                </blockquote>
              )}
              
              {item.description && (
                <p className="text-gray-600 text-sm leading-relaxed mb-3">
                  {item.description}
                </p>
              )}
              
              <div className="flex items-center justify-between mt-4">
                <span className="text-xs text-gray-500">{item.date}</span>
                <button className="text-amber-700 text-sm font-medium group-hover:text-amber-800 transition-colors whitespace-nowrap">
                  {item.type === 'video' ? 'WATCH NOW' : 'READ MORE'}
                  <i className="ri-arrow-right-line ml-1"></i>
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}